__turbopack_context__.v({
  "additionalField": "CCrmProjectManagement-module___ZM44a__additionalField",
  "additionalFieldValue": "CCrmProjectManagement-module___ZM44a__additionalFieldValue",
  "assignedInfo": "CCrmProjectManagement-module___ZM44a__assignedInfo",
  "backButton": "CCrmProjectManagement-module___ZM44a__backButton",
  "childList": "CCrmProjectManagement-module___ZM44a__childList",
  "childPercent": "CCrmProjectManagement-module___ZM44a__childPercent",
  "childRow": "CCrmProjectManagement-module___ZM44a__childRow",
  "chosenType": "CCrmProjectManagement-module___ZM44a__chosenType",
  "chosenTypeDesc": "CCrmProjectManagement-module___ZM44a__chosenTypeDesc",
  "chosenTypeIcon": "CCrmProjectManagement-module___ZM44a__chosenTypeIcon",
  "chosenTypeText": "CCrmProjectManagement-module___ZM44a__chosenTypeText",
  "clearFilters": "CCrmProjectManagement-module___ZM44a__clearFilters",
  "contactLink": "CCrmProjectManagement-module___ZM44a__contactLink",
  "ctaLink": "CCrmProjectManagement-module___ZM44a__ctaLink",
  "deleteWarning": "CCrmProjectManagement-module___ZM44a__deleteWarning",
  "detailGrid": "CCrmProjectManagement-module___ZM44a__detailGrid",
  "detailItem": "CCrmProjectManagement-module___ZM44a__detailItem",
  "detailNote": "CCrmProjectManagement-module___ZM44a__detailNote",
  "detailNoteWarn": "CCrmProjectManagement-module___ZM44a__detailNoteWarn",
  "detailSection": "CCrmProjectManagement-module___ZM44a__detailSection",
  "detailSectionTitle": "CCrmProjectManagement-module___ZM44a__detailSectionTitle",
  "domain": "CCrmProjectManagement-module___ZM44a__domain",
  "entryText": "CCrmProjectManagement-module___ZM44a__entryText",
  "expiredAgo": "CCrmProjectManagement-module___ZM44a__expiredAgo",
  "fileDesc": "CCrmProjectManagement-module___ZM44a__fileDesc",
  "fileLinkBtn": "CCrmProjectManagement-module___ZM44a__fileLinkBtn",
  "fileList": "CCrmProjectManagement-module___ZM44a__fileList",
  "fileRow": "CCrmProjectManagement-module___ZM44a__fileRow",
  "filterField": "CCrmProjectManagement-module___ZM44a__filterField",
  "filters": "CCrmProjectManagement-module___ZM44a__filters",
  "formActions": "CCrmProjectManagement-module___ZM44a__formActions",
  "historyAuthor": "CCrmProjectManagement-module___ZM44a__historyAuthor",
  "historyChanges": "CCrmProjectManagement-module___ZM44a__historyChanges",
  "historyDate": "CCrmProjectManagement-module___ZM44a__historyDate",
  "historyIndex": "CCrmProjectManagement-module___ZM44a__historyIndex",
  "historyItem": "CCrmProjectManagement-module___ZM44a__historyItem",
  "historyItemLocked": "CCrmProjectManagement-module___ZM44a__historyItemLocked",
  "historyList": "CCrmProjectManagement-module___ZM44a__historyList",
  "historyLockedText": "CCrmProjectManagement-module___ZM44a__historyLockedText",
  "historyMeta": "CCrmProjectManagement-module___ZM44a__historyMeta",
  "hoursCell": "CCrmProjectManagement-module___ZM44a__hoursCell",
  "listIntro": "CCrmProjectManagement-module___ZM44a__listIntro",
  "lockedNote": "CCrmProjectManagement-module___ZM44a__lockedNote",
  "name": "CCrmProjectManagement-module___ZM44a__name",
  "nameCell": "CCrmProjectManagement-module___ZM44a__nameCell",
  "note": "CCrmProjectManagement-module___ZM44a__note",
  "nowrap": "CCrmProjectManagement-module___ZM44a__nowrap",
  "orderLink": "CCrmProjectManagement-module___ZM44a__orderLink",
  "pageButton": "CCrmProjectManagement-module___ZM44a__pageButton",
  "pageInfo": "CCrmProjectManagement-module___ZM44a__pageInfo",
  "pagination": "CCrmProjectManagement-module___ZM44a__pagination",
  "panelHeader": "CCrmProjectManagement-module___ZM44a__panelHeader",
  "panelNr": "CCrmProjectManagement-module___ZM44a__panelNr",
  "panelTitle": "CCrmProjectManagement-module___ZM44a__panelTitle",
  "pmCell": "CCrmProjectManagement-module___ZM44a__pmCell",
  "primaryButton": "CCrmProjectManagement-module___ZM44a__primaryButton",
  "priorityBadge": "CCrmProjectManagement-module___ZM44a__priorityBadge",
  "priorityCard": "CCrmProjectManagement-module___ZM44a__priorityCard",
  "priorityCardBody": "CCrmProjectManagement-module___ZM44a__priorityCardBody",
  "priorityCardDesc": "CCrmProjectManagement-module___ZM44a__priorityCardDesc",
  "priorityCardIcon": "CCrmProjectManagement-module___ZM44a__priorityCardIcon",
  "priorityCardName": "CCrmProjectManagement-module___ZM44a__priorityCardName",
  "priorityFieldset": "CCrmProjectManagement-module___ZM44a__priorityFieldset",
  "priorityGrid": "CCrmProjectManagement-module___ZM44a__priorityGrid",
  "priorityHigh": "CCrmProjectManagement-module___ZM44a__priorityHigh",
  "priorityHint": "CCrmProjectManagement-module___ZM44a__priorityHint",
  "priorityLegend": "CCrmProjectManagement-module___ZM44a__priorityLegend",
  "priorityRadio": "CCrmProjectManagement-module___ZM44a__priorityRadio",
  "progressBar": "CCrmProjectManagement-module___ZM44a__progressBar",
  "progressFill": "CCrmProjectManagement-module___ZM44a__progressFill",
  "progressLabel": "CCrmProjectManagement-module___ZM44a__progressLabel",
  "reasonItem": "CCrmProjectManagement-module___ZM44a__reasonItem",
  "reasonList": "CCrmProjectManagement-module___ZM44a__reasonList",
  "regulaminAccept": "CCrmProjectManagement-module___ZM44a__regulaminAccept",
  "regulaminAcceptButton": "CCrmProjectManagement-module___ZM44a__regulaminAcceptButton",
  "regulaminText": "CCrmProjectManagement-module___ZM44a__regulaminText",
  "renewActions": "CCrmProjectManagement-module___ZM44a__renewActions",
  "renewBtn": "CCrmProjectManagement-module___ZM44a__renewBtn",
  "renewIcon": "CCrmProjectManagement-module___ZM44a__renewIcon",
  "richText": "CCrmProjectManagement-module___ZM44a__richText",
  "root": "CCrmProjectManagement-module___ZM44a__root",
  "rowActions": "CCrmProjectManagement-module___ZM44a__rowActions",
  "rowButton": "CCrmProjectManagement-module___ZM44a__rowButton",
  "rowMeta": "CCrmProjectManagement-module___ZM44a__rowMeta",
  "rowNr": "CCrmProjectManagement-module___ZM44a__rowNr",
  "rowStatus": "CCrmProjectManagement-module___ZM44a__rowStatus",
  "searchWrap": "CCrmProjectManagement-module___ZM44a__searchWrap",
  "serviceHeadline": "CCrmProjectManagement-module___ZM44a__serviceHeadline",
  "sortIcon": "CCrmProjectManagement-module___ZM44a__sortIcon",
  "sortIconActive": "CCrmProjectManagement-module___ZM44a__sortIconActive",
  "stateActive": "CCrmProjectManagement-module___ZM44a__stateActive",
  "stateEnded": "CCrmProjectManagement-module___ZM44a__stateEnded",
  "stateReceived": "CCrmProjectManagement-module___ZM44a__stateReceived",
  "stateStopped": "CCrmProjectManagement-module___ZM44a__stateStopped",
  "stepCurrent": "CCrmProjectManagement-module___ZM44a__stepCurrent",
  "stepDone": "CCrmProjectManagement-module___ZM44a__stepDone",
  "stepNext": "CCrmProjectManagement-module___ZM44a__stepNext",
  "stepNo": "CCrmProjectManagement-module___ZM44a__stepNo",
  "steps": "CCrmProjectManagement-module___ZM44a__steps",
  "summaryValue": "CCrmProjectManagement-module___ZM44a__summaryValue",
  "tab": "CCrmProjectManagement-module___ZM44a__tab",
  "tabActive": "CCrmProjectManagement-module___ZM44a__tabActive",
  "tabPanel": "CCrmProjectManagement-module___ZM44a__tabPanel",
  "table": "CCrmProjectManagement-module___ZM44a__table",
  "tableWrap": "CCrmProjectManagement-module___ZM44a__tableWrap",
  "tabs": "CCrmProjectManagement-module___ZM44a__tabs",
  "taskForm": "CCrmProjectManagement-module___ZM44a__taskForm",
  "thInner": "CCrmProjectManagement-module___ZM44a__thInner",
  "thSortable": "CCrmProjectManagement-module___ZM44a__thSortable",
  "toolbar": "CCrmProjectManagement-module___ZM44a__toolbar",
  "truncatedHint": "CCrmProjectManagement-module___ZM44a__truncatedHint",
  "typeCard": "CCrmProjectManagement-module___ZM44a__typeCard",
  "typeCardDesc": "CCrmProjectManagement-module___ZM44a__typeCardDesc",
  "typeCardDisabled": "CCrmProjectManagement-module___ZM44a__typeCardDisabled",
  "typeCardGo": "CCrmProjectManagement-module___ZM44a__typeCardGo",
  "typeCardIcon": "CCrmProjectManagement-module___ZM44a__typeCardIcon",
  "typeCardReason": "CCrmProjectManagement-module___ZM44a__typeCardReason",
  "typeCardTitle": "CCrmProjectManagement-module___ZM44a__typeCardTitle",
  "typeError": "CCrmProjectManagement-module___ZM44a__typeError",
  "typeGrid": "CCrmProjectManagement-module___ZM44a__typeGrid",
  "unassigned": "CCrmProjectManagement-module___ZM44a__unassigned",
});
